import { sdk } from 'src/utilities/sdk';

export type EmailAvailabilityResponse = {
  available: boolean;
};

export const getEmailCheckUrl = (corpId: string): string =>
  `/corp-admin/${corpId}/diners/email-availability`;

export async function getEmailAvailability(
  corpId: string,
  email: string
): Promise<EmailAvailabilityResponse> {
  try {
    const data = await sdk.http.post(getEmailCheckUrl(corpId), { email });

    return data;
  } catch (error) {
    return Promise.reject(error);
  }
}
